module.exports = __webpack_public_path__ + "placeholderwp920149a7e0c92ef425128d06546ef898.jpg";